export const SHOW_GRADING_FEEDBACK = {
  ALWAYS: 0,
  COMPLETION: 5,
  NEVER: 10
}

export const ALLOW_RESETS = {
  ALWAYS: 0,
  BEFORE: 5
}
